import React from 'react'

function Spinner() {
  return (
    <div className='animate-ping w-36 h-36 rounded-full bg-blue-900'>
      
    </div>
  )
}

export default Spinner
